(function () {
    'use strict';

    angular.module('swif.achats')

    .config(['$routeProvider', function($routeProvider) {
/*        $routeProvider.when('/configuration/absence_category/table_view', {
            templateUrl: 'partials/openstc/absence_category_table_view.html',
            controller: 'AbsenceCategoriesController',
            reloadOnSearch: false
        });*/
    }]);


})();
